import React from 'react';
import styled from 'styled-components';
import {COLORS, ELEVATIONS, SIZES, Typography} from '@fupa/fupa-uikit';
import {InfoCardImage} from 'app/components/infoCard/InfoCardImage';
import {Information} from 'app/components/infoCard/Information';
import {object} from 'prop-types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.white};
  box-shadow: ${ELEVATIONS.Card};
  height: auto;
  margin-bottom: ${SIZES['16']};
  width: 100%;
  max-width: 30.75rem;
  border: 1px solid ${COLORS.black};
  padding: ${SIZES['16']};
  @media only screen and (max-width: 508px) {
    padding: ${SIZES['16']} ${SIZES['8']};
  }
`;

const CardHeader = styled.div`
  display: flex;
  padding-bottom: ${SIZES['12']};
`;

const ScalingTypography = styled(Typography)`
  &&& {
    margin: 0;
    font-weight: bold;
    @media only screen and (min-width: 492px) {
      font-size: ${SIZES['20']};
    }
  }
`;

const CatchPhrase = styled(Typography)`
  &&& {
    font-weight: bold;
    @media only screen and (min-width: 492px) {
      font-size: ${SIZES['16']};
    }
  }
`;

const InfoCard = ({data}) => {
  return (
    <Wrapper>
      <CardHeader>
        <ScalingTypography variant='subheading' component='h3'>
          {data.heading}
        </ScalingTypography>
      </CardHeader>
      <InfoCardImage basicName={data.image.basicName} altText={data.image.alt} />
      <Information content={data.content} />
      <CatchPhrase variant='body1'>{data.catchPhrase}</CatchPhrase>
    </Wrapper>
  );
};

InfoCard.propTypes = {
  data: object.isRequired,
};

export {InfoCard};
